import React from "react";
import { ReactComponent as CircleTickIcon } from "../assets/circle_tick.svg";
import CustomButton from "./CustomButton";
import { Modal } from "@mantine/core";

const SuccessPopUp = ({
  opened,
  close,
  messageText = "",
  messagePara = "",
}) => {
  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      radius={"xl"}
      size={"lg"}
      withCloseButton={false}
    >
      <div className="universal-modal-wrapper">
        <CircleTickIcon />
        <h1
          className="header"
          style={{ color: "#314064", textAlign: "center" }}
        >
          {messageText}
        </h1>
        <p
          style={{ textAlign: "center", color: "#222222" }}
          className="sub-header"
        >
          {messagePara}
        </p>
        <CustomButton
          style={{ width: "50%" }}
          btnText={"BACK"}
          flex={1}
          onClick={close}
        />
      </div>
    </Modal>
  );
};

export default SuccessPopUp;
